import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreReducers, CoreState } from "@reco-m/core";
import { app } from "@reco-w/core-ui";
import { tagService } from "@reco-m/tag-service";

import { Namespaces } from "./common";
import { r2040ArticleService } from "src/apps/common/common/r2040article.service";
import { EnumGroupHomeTag } from "@reco-w/common-common";

export namespace informationModel {
    export const namespace = Namespaces.information;

    export const state: any = freeze(
        {
            ...CoreState,
            showloading: true,
            isInputTimeDesc: true,
            isPopularityDesc: true,
        },
        !0
    );

    export type StateType = typeof state;

    export const reducers: ReducersMapObject = {
        ...CoreReducers,
        initState() {
            return state;
        },
    };

    export const effects: EffectsMapObject = {
        ...CoreEffects,
        *initPage({ fail, data }, { put, call }) {
            put({ type: "showLoading" });
            try {
                const tagData = yield call(tagService.getTagByTagClass, { tagClass: 'SERVICEMANAGE/ZIXLX' });

                const tags: any[] = tagData.filter(x => [EnumGroupHomeTag.xinwzx, EnumGroupHomeTag.tongztg, EnumGroupHomeTag.huodjj].indexOf(x.id) > -1);
                tags.unshift({ id: tags.map(x => x.id), tagName: '全部' })
                const tagId = data.tagId || tags[0].id;

                if (data.tagId) {
                    yield put({ type: "input", data: { tabsIndex: tags.findIndex(x => x.id === data.tagId) } });
                }

                yield put({ type: "input", data: { tagList: tags, tagId: tagId } });
                yield put({ type: "getData", data: { inTagIds: tagId, ...data } });
            } catch (e) {
                fail(e);
            }
        }, *getData({ data, message }, { put, call }) {
            try {
                yield put({ type: "showLoading" });
                const params = yield call(r2040ArticleService.getPaged, { ...data, isValid: true, orderBy: 'isTop,sequence,id desc' });
                yield put({ type: "input", data: params });
            } catch (e) {
                yield call(message!.error, "getData:" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        }, *get({ fail, data }, { put, call }) {
            put({ type: "showLoading" });
            try {
                const article = yield call(r2040ArticleService.get, data);
                yield put({ type: "input", data: { article } });
            } catch (e) {
                fail(e);
            }
        }
    };
}

app.model(informationModel);
